import { render, staticRenderFns } from "./thirdRank.vue?vue&type=template&id=274b08f4&scoped=true&"
import script from "./thirdRank.vue?vue&type=script&lang=js&"
export * from "./thirdRank.vue?vue&type=script&lang=js&"
import style0 from "./thirdRank.vue?vue&type=style&index=0&id=274b08f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274b08f4",
  null
  
)

export default component.exports